import { CITIES } from "../../data/cities";
import { SITE } from "../../data/site";

const SITE_ORIGIN = "https://atctermiteservices.com";

export const HOMEPAGE_SEO = {
  title:
    "Termite Control PA & MD | 35+ Years, Zero Retreats | ATC Pest Control",
  description:
    "Family-owned termite experts serving Pennsylvania & Maryland since 1991. 35+ years without a single retreat. Licensed, insured, fast scheduling. Call (717) 356-0740.",
  canonical: `${SITE_ORIGIN}/`,
  jsonLd: {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "PestControlService"],
    name: "ATC Pest Control",
    alternateName: "ATC Termite Services",
    image: `${SITE_ORIGIN}/generated/hero_home.jpg`,
    telephone: "+1-717-356-0740",
    email: SITE.email,
    url: `${SITE_ORIGIN}/`,
    priceRange: "$$",
    description:
      "Family-owned termite and pest control experts serving Pennsylvania & Maryland since 1991. 35+ years without a single termite retreat.",
    foundingDate: "1991",
    address: {
      "@type": "PostalAddress",
      streetAddress: "4131 Huffmanville Road",
      addressLocality: "Glen Rock",
      addressRegion: "PA",
      postalCode: "17327",
      addressCountry: "US",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 39.7909,
      longitude: -76.7333,
    },
    areaServed: CITIES.map((c) => ({
      "@type": "City",
      name: `${c.city}, ${c.stateCode}`,
    })),
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        opens: "07:00",
        closes: "19:00",
      },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      reviewCount: "148",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Termite Services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "One-Time Termite Treatment",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Annual Termite Protection Program",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Wood Destroying Insect Report (WDIR)",
          },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Termite Inspection" },
        },
      ],
    },
  },
};
